import { apiClient, getUserId } from "./authService";

interface PromoData {
  [key: string]: any;
}

export const getAllStaff = async (): Promise<any> => {
  try {
    const userId = getUserId();
    const response = await apiClient.post(`/users/by_owner`, {
      user_id: userId
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createStaff = async (staffData: PromoData): Promise<any> => {
  try {
    const admin_user_id = getUserId();
    const payload = { ...staffData, admin_user_id };
    const response = await apiClient.post("/users/create", payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateStaff = async (
  id: string,
  staffData: PromoData
): Promise<any> => {
  try {
    const response = await apiClient.put(`/users/edit/${id}`, staffData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getStaffById = async (id: string): Promise<any> => {
  try {
    const response = await apiClient.get(`/clients/view/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteStaff = async (id: string): Promise<any> => {
  try {
    const response = await apiClient.delete(`/allusers/delete/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
